import React, { Component } from "react";
import { getClientId } from "./utils/analyticsclientIdUtils";
import ZPartnerLSC0Header from "./ZPartnerLSC0Header";
import ZPartnerLSC0Footer from "./ZPartnerLSC0Footer";

import { Redirect_Url_2 } from "./ZPartnerLSCUrls";

export class LSC_JoinNowError01 extends Component {
    static displayName = LSC_JoinNowError01.name;

    constructor(props) {
        super(props);
        this.state = {
            message: "LSC_JoinNowError01"            
        };
    }

    componentDidMount() {
        //const links = [
        //    "https://fonts.googleapis.com/css?family=Lato:300&text=1234567890,.-",
        //    "/css/lsc/style_01.css",
        //    "/css/lsc/style_02.css",
        //    "/css/lsc/style_03.css",
        //    "/css/lsc/691208892_en-US.css",
        //    "/css/lsc/line_my_card.css"
        //];

        //links.forEach(href => {
        //    const link = document.createElement("link");
        //    link.rel = "stylesheet";
        //    link.href = href;
        //    document.head.appendChild(link);
        //});

        // Google Analytics / GTM tracking (same idea as EnAuthSignin)
        const documentPath = "LSC_Joinnow_Thx";
        const clientId = getClientId();

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "pageview",
            page: documentPath,
            clientId: clientId
        });

        // #region "back button / history handling"
        if (typeof window !== "undefined" && window.history && window.history.pushState) {
            // keep reference for removeEventListener later
            this.handlePopState = () => {
                const hashLocation = window.location.hash;
                const hashSplit = hashLocation.split("#!/");
                const hashName = hashSplit[1];

                if (hashName !== "") {
                    const hash = window.location.hash;
                    if (hash === "") {
                        window.location = Redirect_Url_2;
                        return false;
                    }
                }
            };

            window.addEventListener("popstate", this.handlePopState);

            // same as original: push fake state into history
            window.history.pushState("forward", null, "./#forward");
        }
        // #endregion
    }

    handleSubmit = async (e) => {
        e.preventDefault();

        window.location.replace(Redirect_Url_2);
    };
    
    render() {
        const {
            message
        } = this.state;

        return (
            <>
                <ZPartnerLSC0Header />

                <main id="main">
                    <section className="section-sign-in overflow-hidden pb-5">
                        <div className="container p-1 p-md-0">
                            <div className="row">
                                <div className="col-md-12 mb-5 pt-3 text-center">
                                    <h2 className="h3 mt-5 fw-bold text-dark-212121">
                                        สร้างบัญชีสตาร์บัคส์ใหม่<br />
                                        Create an account
                                    </h2>
                                </div>
                            </div>
                            <div className="row justify-content-center px-1 px-md-5">
                                <div className="col-md-6 mb-3 pt-3">
                                    <div className="py-5 p-4 box-sign-in">
                                        <form className="form-sr px-1" onSubmit={this.handleSubmit}>
                                            <div className="mb-4 text-center">
                                                <p>
                                                    อีเมลนี้ลงทะเบียนสมาชิก Starbucks® Rewards แล้ว<br />
                                                    เปิดใช้งาน LINE Starbucks Card คลิกที่นี่
                                                </p>
                                                <p>
                                                    This email has been registered with Starbucks® Rewards<br />
                                                    To enable LINE Starbucks Card, please click here.
                                                </p>
                                            </div>
                                            <div className="text-center">
                                                <button className="btn btn-primary rounded-pill px-4">
                                                    เข้าสู่ LINE Starbucks Card<br />
                                                    Return to LINE Starbucks Card
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>                

                <ZPartnerLSC0Footer />
            </>
        );
    }
}
